import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { toast } from 'sonner';
import { Zap, Loader2 } from 'lucide-react';

const deriveTitle = (text) => {
  const firstLine = (text.split('\n').find(l => l.trim()) || '').trim();
  return firstLine.slice(0, 80) || 'Snelle notitie';
};

export const BrainDumpCard = ({ onSaved }) => {
  const { authAxios } = useAuth();
  const [text, setText] = useState('');
  const [saving, setSaving] = useState(false);

  const handleSave = async () => {
    const body = text.trim();
    if (!body) {
      toast.error('Schrijf eerst iets op');
      return;
    }
    setSaving(true);
    try {
      const api = authAxios();
      const title = deriveTitle(body);
      await api.post('/entries', {
        location_id: 'all',
        title,
        content: body,
        entry_status: 'active',
        source: 'manual',
      });
      toast.success('Opgeslagen — de AI sorteert het zo in.');
      setText('');
      if (onSaved) onSaved();
    } catch (e) {
      toast.error('Fout bij opslaan');
    } finally {
      setSaving(false);
    }
  };

  const handleKeyDown = (e) => {
    if ((e.metaKey || e.ctrlKey) && e.key === 'Enter') {
      e.preventDefault();
      handleSave();
    }
  };

  return (
    <div
      className="bg-white dark:bg-[#161B22] rounded-xl border border-slate-200/80 dark:border-[#21262D] p-4 shadow-sm border-t-[3px] border-t-[#2E75B6]"
      data-testid="brain-dump-card"
    >
      <div className="flex items-center gap-2 mb-2.5">
        <Zap className="w-4 h-4 text-[#2E75B6]" />
        <h2 className="font-heading text-base font-semibold text-slate-900 dark:text-[#E6EDF3]">Snel vastleggen</h2>
      </div>
      <textarea
        data-testid="brain-dump-textarea"
        value={text}
        onChange={(e) => setText(e.target.value)}
        onKeyDown={handleKeyDown}
        placeholder="Typ een gedachte, deadline of notitie... de AI sorteert het daarna automatisch in."
        rows={3}
        className="w-full px-3 py-2 rounded-lg border border-slate-200 dark:border-[#30363D] bg-white dark:bg-[#0D1117] text-slate-900 dark:text-[#E6EDF3] text-sm focus:outline-none focus:ring-2 focus:ring-[#2E75B6]/40 focus:border-[#2E75B6] transition-colors resize-none"
      />
      <div className="flex items-center justify-between mt-2.5">
        <span className="text-[11px] text-slate-400 dark:text-slate-500 hidden sm:inline">Geen velden nodig — gewoon opschrijven en bewaren.</span>
        <button
          type="button"
          data-testid="brain-dump-save"
          onClick={handleSave}
          disabled={saving || !text.trim()}
          className="inline-flex items-center gap-1.5 px-4 py-2 rounded-lg bg-[#2E75B6] text-white text-sm font-medium hover:bg-[#27649C] active:scale-[0.98] transition-colors disabled:opacity-50"
        >
          {saving ? <Loader2 className="w-4 h-4 animate-spin" /> : <Zap className="w-4 h-4" />}
          {saving ? 'Bewaren...' : 'Bewaar'}
        </button>
      </div>
    </div>
  );
};
